const API_BASE_URL =
  process.env.REACT_APP_LOA_API_BASE_URL || "https://loas-backend.onrender.com";

const getFilePasswordKey = (file) => {
  return `${file.name}-${file.size}-${file.lastModified}`;
};

export const createCedingSchemeExtractionJob = async ({
  userEmail,
  adviserEmail,
  schemes,
  additionalInstructions,
}) => {
  const formData = new FormData();

  formData.append("userEmail", userEmail || "");
  formData.append("adviserEmail", adviserEmail || userEmail || "");
  formData.append("additionalInstructions", additionalInstructions || "");

  const schemesMeta = schemes.map((scheme, index) => ({
    id: scheme.id,
    name: scheme.name || `Ceding Scheme ${index + 1}`,
    notes: scheme.notes || "",
    fileCount: scheme.files?.length || 0,
    fileNames: (scheme.files || []).map((file) => file.name),

    files: (scheme.files || []).map((file) => ({
      name: file.name,
      size: file.size || null,
      lastModified: file.lastModified || null,
      password: scheme.filePasswords?.[getFilePasswordKey(file)] || "",
    })),
  }));

  formData.append("schemesJson", JSON.stringify(schemesMeta));

  schemes.forEach((scheme) => {
    scheme.files.forEach((file) => {
      formData.append(`schemeFiles:${scheme.id}`, file);
    });
  });

  const url = `${API_BASE_URL}/api/extraction/ceding-scheme/job`;

  console.log("Creating LOA extraction job:", url);

  const response = await fetch(url, {
    method: "POST",
    body: formData,
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(
      data.error || data.message || "Failed to create extraction job.",
    );
  }

  return data;
};
